import {
  rearrangeOnDraggingBetweenElements,
  rearrangeOnDraggingAtEndOfElements,
} from '../rearrangeCards';
import IsInEditorViewPort from '../utils/IsInEditorViewPort';
import scrollToElement from '../utils/scrollToElement';

export default (params) => {
  const {
    parentNode,
    afterRole,
    editor,
    currentNodeKey,
    dragType,
    node,
    el,
    mostUsedToolSetRef,
    statusBarRef,
  } = params;

  const {
    value: { document: editorDocument },
  } = editor;

  const parentOrgElement = parentNode.parentElement;
  const parentOrgKey = parentOrgElement.getAttribute('data-key');
  const parent = editorDocument.getNode(parentOrgKey);

  if (afterRole) {
    const afterRoleKey = afterRole.getAttribute('data-key');
    const afterRoleNode = editorDocument.getNode(afterRoleKey);
    rearrangeOnDraggingBetweenElements({
      editor,
      parent,
      afterRoleNode,
      currentNodeKey,
      dragType,
    });
  } else {
    const {
      nodes: { size: nodesSize },
    } = parent;
    rearrangeOnDraggingAtEndOfElements({
      editor,
      currentNodeKey,
      parent,
      newIndex: nodesSize,
      dragType,
    });
  }

  const { data: currNodeData } = node;
  const currNodeExport = currNodeData.get('toExport');
  if (currNodeExport) {
    const { key: prevParentKey, data: prevParentData } =
      editorDocument.getParent(currentNodeKey);

    const { key: newParentKey } = parent;
    if (prevParentKey !== newParentKey) {
      const { data: currParentData } = parent;
      const currParentJSON = currParentData.toJSON();
      const { selectAll: currParentSelectAll } = currParentJSON;

      const prevParentJSON = prevParentData.toJSON();
      const { selectAll: prevParentSelectAll } = prevParentJSON;

      editor
        .setNodeByKey(prevParentKey, {
          data: {
            ...prevParentJSON,
            selectAll: prevParentSelectAll - 1,
          },
        })
        .setNodeByKey(newParentKey, {
          data: {
            ...currParentJSON,
            selectAll: currParentSelectAll + 1,
          },
        });
    }
  }
  if (el) {
    if (IsInEditorViewPort(el, mostUsedToolSetRef, statusBarRef)) return true;
    scrollToElement(el);
  }

  return false;
};
